<template>
  <v-dialog v-model="show" persistent eager max-width="350">
    <v-card>
        <v-toolbar color="error" class="ps-4"
          ><h3>
            {{ title + " (" + $t("config.delete") + ")" }}
          </h3>
        </v-toolbar>

        <v-card-text>{{ $t("config.delete") + text }}</v-card-text>

        <v-card-actions class="pb-5 pr-4">
          <v-spacer></v-spacer>
          <v-btn
            @click="deleteFunction()"
            variant="flat"
            color="error"
          >
            {{ $t("config.delete") }}</v-btn
          >
          <v-btn @click="show = false" variant="outlined">{{
            $t("config.cancel")
          }}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfigYearDeleteDialog",
  props: {
    modelValue: Boolean,//บังคับใช้
    deleteFunction: Function,
    text: String,
    title: String,
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
    },
  },
};
</script>
